import { PageHeading, Pagination } from 'components/atoms';
import { Head, PageLayout } from 'components/molecules';
import BlurredEintragungenList
  from 'components/molecules/Eintragungen/EintragungenList/BlurredEintragungenList';
import Eintragungenlist from 'components/molecules/Eintragungen/EintragungenList/Eintragungenlist';
import EintragungenFilter from 'components/molecules/Eintragungen/Filter/EintragungenFilter';
import ScheinunternehmenPremiumCta from 'components/molecules/Eintragungen/Filter/PremiumCta/ScheinunternehmenPremiumCta';
import { getTranslations } from 'i18n';
import type { GetServerSideProps, NextPage } from 'next';
import { useSession } from 'next-auth/react';
import React from 'react';
import { ISO8601Date } from 'types';
import type { Eintragung } from 'types/eintragungen';
import { getCanonicalUrl } from 'utils';
import { useTranslation } from 'utils/hooks';
import { getEintragungen } from 'utils/listStaticProps';




interface ScheinunternehmenEintragungenPageProps
{
  limit: number;
  page: number;
  total: number;
  aktuell: ISO8601Date;
  filters: Record<string, string>;
  scheinunternehmenEintragungen: Eintragung[];
}

const ScheinunternehmenEintragungenPage: NextPage<ScheinunternehmenEintragungenPageProps> = (props) =>
{
  const { filters, scheinunternehmenEintragungen, page, limit, total, aktuell } = props;
  const { t } = useTranslation();

  const { status } = useSession();
  const isPlus = status == 'authenticated';

  return (
    <PageLayout>

      <Head
        title={t('eintragungen:scheinunternehmen.seoTitle')}
        description={t('eintragungen:scheinunternehmen.seoDescription')}
      >
        <link rel="canonical" href={`${getCanonicalUrl()}/l/scheinfirmen`}/>
      </Head>

      {isPlus ? (
        <EintragungenFilter
          defaultValues={filters}
          aktuell={aktuell}
          eintragungsart={'scheinfirmen'}
          dateOptions={[]}
        />
      ) : <ScheinunternehmenPremiumCta/>}

      <PageHeading title={t('eintragungen:scheinunternehmen.heading', { count: total })}/>

      <Eintragungenlist eintragungen={scheinunternehmenEintragungen}/>
      {!isPlus && <BlurredEintragungenList eintragungen={scheinunternehmenEintragungen.slice(0, 2)}/>}

      {isPlus && scheinunternehmenEintragungen.length > 0 && (
        <Pagination
          activePage={page}
          limit={limit}
          totalResults={total}
          shallow={false}
          scrollTop
        />
      )}

    </PageLayout>
  );
};

export default ScheinunternehmenEintragungenPage;

export const getServerSideProps: GetServerSideProps = async (ctx) => 
{
  const { locale } = ctx;
  const translations = await getTranslations(locale, 'common', 'eintragungen', 'bundesländer');
  const props = await getEintragungen(ctx, 'scheinunternehmenEintragungen');

  return { props: { ...props, ...translations } };
};